import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { captureBuilderIOKitException } from './init';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        captureBuilderIOKitException(error);
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }
        return this.props.children;
    }
}
export const withErrorBoundary = (Component) => (props) => (_jsx(ErrorBoundary, Object.assign({ fallback: props.fallback }, { children: _jsx(Component, Object.assign({}, props)) })));
//# sourceMappingURL=ErrorBoundary.js.map